"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _cancelEntry = _interopRequireDefault(require("../cancel-entry"));
var _waitingListManagement = _interopRequireDefault(require("../waiting-list-management"));
var _selectNewRace = _interopRequireDefault(require("./select-new-race"));
var _confirmChanges = _interopRequireDefault(require("./confirm-changes"));
var _existingEntry = _interopRequireDefault(require("./existing-entry"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Sorry we do not have details of the new bib yet");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "The paddler is no longer eligible to race at the competition, you should cancel their entry");
class ManagePromotionModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isProcessing: false,
      newRace: null,
      message: null,
      promotedOnWaitingList: false
    });
    // If possible we want to keep paddler in same race.  This will keep officials in officals races
    // but also paddle ups in the same race but as host.
    //
    // If we can't keep them in the same race then we try to keep the same type of entry
    // so host paddlers stay as host paddlers.  This will handle those who entered as div 3 and
    // have been promoted to div 2 etc.
    //
    // If we can't do that then we give any available options to the organiser
    _defineProperty(this, "_getPossibleRaces", promotedToBib => {
      if (!(promotedToBib && promotedToBib.classDivision.eligibilities)) return [];
      let eligibilities = promotedToBib.classDivision.eligibilities;
      if (eligibilities.filter(elg => elg.raceID === this.props.entry.race.id).length) eligibilities = eligibilities.filter(elg => elg.raceID === this.props.entry.race.id);else if (eligibilities.filter(elg => elg.entryTypeID === this.props.entry.entryTypeID).length) eligibilities = eligibilities.filter(elg => elg.entryTypeID === this.props.entry.entryTypeID);
      return eligibilities.map(elg => ({
        raceID: elg.raceID,
        raceName: elg.race.raceName,
        entryTypeID: elg.entryTypeID,
        entryTypeDescription: elg.entryType.description,
        hasExistingEntry: !!elg.race.entry,
        existingEntryStatusRef: elg.race.entry ? elg.race.entry.entryStatusRef : null,
        existingEntryStatusDescription: elg.race.entry ? elg.race.entry.entryStatusDescription : null,
        hasPaidForExistingEntry: elg.race.entry ? elg.race.entry.paymentID || elg.race.entry.hasPaid : null
      }));
    });
    // Default race if paddler can enter the same race or as the same entryType otherwise force selection
    _defineProperty(this, "_getNewRace", possibleRaces => {
      if (this.state.newRace) return this.state.newRace;
      if (possibleRaces.length === 1 && (possibleRaces[0].raceID === this.props.entry.race.id || possibleRaces[0].entryTypeID === this.props.entry.entryTypeID)) return possibleRaces[0];
      return;
    });
    _defineProperty(this, "_setNewRace", (raceID, possibleRaces) => {
      this.setState({
        newRace: possibleRaces.filter(r => r.raceID === raceID)[0]
      });
    });
    _defineProperty(this, "_onChangeEntryFollowingPromotion", raceID => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      this.props.changeEntryFollowingPromotion(this.props.entry.id, raceID).then(result => {
        if (!result.success) {
          this.setState({
            message: result.message
          });
        } else if (this.props.entry.entryStatusRef === 'WAIT') {
          this.setState({
            promotedOnWaitingList: true
          });
        } else if (result.message) {
          this.setState({
            message: result.message
          });
        } else {
          this.props.onToggleRequest();
        }
      });
    });
  }
  render() {
    const entry = this.props.entry;
    const promotedToBib = this.props.promotedToBib;
    const possibleRaces = this._getPossibleRaces(promotedToBib);
    const newRace = this._getNewRace(possibleRaces);
    const modalTitle = entry.classDescription + ' ' + entry.rankingDivisionDescription + (entry.bibNumber ? ' Bib ' + entry.bibNumber + ' ' : ' ') + (entry.bibName || '') + (!promotedToBib ? ' is Recent Promotee ' : ' has been promoted to ' + promotedToBib.rankingDivisionDescription + ' Bib ' + promotedToBib.bibNumber);
    const canConfirmChange = !this.state.message && newRace && (!newRace.hasExistingEntry || newRace.existingEntryStatusRef === 'DRFT');
    const showCancelEntryButton = !this.state.message && (!possibleRaces.length || !newRace || newRace.hasExistingEntry && newRace.existingEntryStatusRef !== 'DRFT');
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onToggleRequest
    }, this.state.promotedOnWaitingList || this.state.message || showCancelEntryButton ? 'Close' : 'Cancel'), !canConfirmChange ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => this._onChangeEntryFollowingPromotion(newRace.raceID),
      type: "primary",
      disabled: this.state.isProcessing
    }, "Confirm Change"), !this.state.promotedOnWaitingList ? null : /*#__PURE__*/_react.default.createElement(_waitingListManagement.default, {
      entry: entry,
      buttonSize: "md",
      block: false,
      type: "primary",
      onCloseCancel: this.props.onToggleRequest
    }), !showCancelEntryButton ? null : /*#__PURE__*/_react.default.createElement(_cancelEntry.default, {
      entry: entry,
      buttonSize: "md",
      block: false,
      onCloseCancel: this.props.onToggleRequest,
      type: "primary"
    }));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: modalButtons,
      onClose: this.props.onToggleRequest,
      title: modalTitle
    }, this.state.message ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.message) : !promotedToBib ?
    // No new bib info
    // because we've already processed the promotion but they are on waiting list
    this.state.promotedOnWaitingList ? /*#__PURE__*/_react.default.createElement("p", null, entry.bibName, " is still on the waiting list. They will not be able to complete and pay for their entry until you have offered them a place.") : _ref : /*#__PURE__*/_react.default.createElement("div", null, !possibleRaces.length ? _ref2 : !newRace ? /*#__PURE__*/_react.default.createElement(_selectNewRace.default, {
      possibleRaces: possibleRaces,
      entry: entry,
      setNewRace: this._setNewRace,
      onToggleRequest: this.props.onToggleRequest
    }) : newRace.hasExistingEntry && newRace.existingEntryStatusRef !== 'DRFT' ? /*#__PURE__*/_react.default.createElement(_existingEntry.default, {
      newRace: newRace
    }) : /*#__PURE__*/_react.default.createElement(_confirmChanges.default, {
      entry: this.props.entry,
      newRace: newRace
    }))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(ManagePromotionModal, "partialQueries", {
  Entry: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    id: true,
    rankingDivisionDescription: true,
    classDescription: true,
    bibNumber: true,
    bibName: true,
    entryStatusRef: true,
    promotion: {
      yearID: true,
      promotedToBibID: true
    },
    race: {
      id: true,
      competitionDayID: true,
      raceName: true
    }
  }, _cancelEntry.default.partialQueries.Entry), _selectNewRace.default.partialQueries.Entry), _confirmChanges.default.partialQueries.Entry), _waitingListManagement.default.partialQueries.Entry)
});
var _ref3 = {
  description: true
};
var _ref4 = {
  id: true,
  entryStatusRef: true,
  entryStatusDescription: true,
  paymentID: true,
  hasPaid: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ManagePromotionModal, props => {
  if (!props.entry || !props.entry.promotion || !props.entry.promotion.promotedToBibID) return {};
  return {
    ["cseBib(cseBibID:" + JSON.stringify(+props.entry.promotion.promotedToBibID) + ") as promotedToBib"]: {
      bibNumber: true,
      rankingDivisionDescription: true,
      classDivision: {
        ["raceEligibilitiesByCompetitionDay(competitionDayID:" + JSON.stringify(+props.entry.race.competitionDayID) + ") as eligibilities"]: {
          entryTypeID: true,
          entryType: _ref3,
          raceID: true,
          race: {
            raceName: true,
            ["entry(cseBibID:" + JSON.stringify(+props.entry.promotion.promotedToBibID) + ")"]: _ref4
          }
        }
      }
    }
  };
}, (client, props) => ({
  changeEntryFollowingPromotion(entryID, newRaceID) {
    return client.update('EntryPromotion.changeEntryFollowingPromotion', {
      entryID,
      newRaceID
    });
  }
}));